module.exports = __webpack_public_path__ + "img/zoe_estates_bg_006.a38bc078.jpg";